import React, { useEffect, useMemo } from "react";
import FormSelect from "Common/Custom/FormSelect";
import FormInput from "Common/Custom/FormInput";
import { RoomFieldsOpction } from "../HELPERS/Helpers";

// ── Part 1: Room Info fields ──────────────────────────────────────────────────
// Reads showFor from JSON — no hardcoded field names here
export const RoomInfoFields = ({
    RoomFields,
    room,
    index,
    PreveBookedRoomIds,
    ChildrenMinAge,
    roomTypesOption,
    roomNumbersByType,
    selectedRoomIds,
    onRoomFieldEvent,
    values,
    errors,
    isLoadingRooms,
}) => {
    const handleChange = useMemo(
        () => onRoomFieldEvent(index),
        [onRoomFieldEvent, index]
    );

    const isRoomIdLocked = useMemo(
        () => PreveBookedRoomIds.includes(room.book_details_id),
        [PreveBookedRoomIds, room.book_details_id]
    );

    const isInputDisabled = useMemo(
        () => !room.room_type_id || !room.room_id,
        [room.room_type_id, room.room_id]
    );

    // Filter by showFor from JSON — no hardcoded names
    const visibleFields = useMemo(
        () =>
            RoomFields.filter((field) => {
                if (!field.showFor) return true;
                if (!room.accommodation_type) return true;
                return field.showFor.includes(room.accommodation_type);
            }),
        [RoomFields, room.accommodation_type]
    );

    return (
        <>
            {visibleFields.map((field, idx) => {
                if (field.type === "select") {
                    return (
                        <FormSelect
                            key={idx}
                            field={field}
                            value={room[field.name]}
                            disabled={
                                (field.name === "room_type_id" ? (isRoomIdLocked || (!values.checkin_date || !values.checkout_date)) : false)
                            }
                            options={RoomFieldsOpction(
                                field.name,
                                room,
                                roomTypesOption,
                                roomNumbersByType,
                                selectedRoomIds
                            )}
                            handleChange={handleChange}
                            error={errors?.[index]?.[field.name]}
                            isLoading={isLoadingRooms}
                        />
                    );
                }
                const fieldError =
                    field.name === "no_of_people" &&
                        Number(room?.no_of_people) > Number(room?.capacity)
                        ? `Adults Maximum Limit ${room.capacity}`
                        : field.name === "no_of_bed" &&
                            Number(room?.no_of_bed) > Number(room?.avalible_beds)
                            ? `Maximum Beds ${room.avalible_beds || 0}`
                            : errors?.[index]?.[field.name];

                return (
                    <FormInput
                        key={idx}
                        field={{
                            ...field,
                            label:
                                field.name === "children"
                                    ? `Children (Age Below ${ChildrenMinAge})`
                                    : field.name === "no_of_bed"
                                        ? `No of Bed (Max ${room.avalible_beds || 0})`
                                        : field.label,
                            disabled: isInputDisabled,
                            placeholder: field.name === "no_of_people" ? `Adults (Max ${room?.capacity})` : field.placeholder

                        }}
                        value={room[field.name]}
                        handleChange={handleChange}
                        error={fieldError}
                    />
                );
            })}
        </>
    );
};

export const RentInfoFields = ({
    Rent_Info,
    room,
    index,
    rooms,
    errors,
    complementryByType,
    onRoomFieldEvent,
    isLoadingRooms
}) => {
    const handleChange = useMemo(
        () => onRoomFieldEvent(index),
        [onRoomFieldEvent, index]
    );

    const complementaryOptions = useMemo(() => {
        const { room_type_id, room_id } = room;
        if (!room_type_id || !room_id) return [];

        const roomKey = `${room_type_id}_${room.Unic_key}`;


        return (complementryByType[roomKey] || []).map((c) => ({
            value: c.complementary_id,
            label: c.complementary_name,
        }));
    }, [room.room_type_id, room.room_id, complementryByType, index]);

    // Filter fields by showFor
    const visibleFields = useMemo(
        () =>
            Rent_Info.filter((field) => {
                if (!field.showFor) return true;
                if (!room.accommodation_type) return true;
                return field.showFor.includes(room.accommodation_type);
            }),
        [Rent_Info, room.accommodation_type]
    );

    return (
        <>
            {visibleFields.map((field, idx) => {
                // Skip billing summary fields
                if (field.billingSummaryOnly) return null;

                if (field.type === "select") {
                    return (
                        <FormSelect
                            key={idx}
                            field={field}
                            value={room?.[field.name]}
                            disabled={!room?.room_type_id}
                            options={complementaryOptions}
                            handleChange={handleChange}
                            error={errors?.[index]?.[field.name]}
                            isLoading={isLoadingRooms}
                        />
                    );
                }

                return (
                    <FormInput
                        key={idx}
                        field={{ ...field }}
                        value={
                            field.name === "noofroom"
                                ? rooms?.length || 0
                                : room?.[field.name] || ""
                        }
                        handleChange={handleChange}
                        error={
                            errors?.[index]?.[field.name]
                        }
                    />
                );
            })}
        </>
    );
};